import { Injectable } from '@angular/core'
import { map } from 'rxjs'

import {
  GetAllFieldsGQL,
  GetAllFieldsInput,
  GetBooleanValueGQL,
  GetBooleanValueInput,
  GetDateValueGQL,
  GetDateValueInput,
  GetFloatValueGQL,
  GetFloatValueInput,
  GetGroupFieldDefinitionByIdGQL,
  GetGroupValueByIdGQL,
  GetGroupValueGQL,
  GetGroupValueInput,
  GetIntegerValueGQL,
  GetIntegerValueInput,
  GetRelationValueGQL,
  GetRelationValueInput,
  GetRichTextValueGQL,
  GetRichTextValueInput,
  GetStringValueGQL,
  GetStringValueInput,
  GetTemplatesByEntityIdGQL,
  GetUniqueTemplatesGQL,
  GroupValue,
} from '../gql/generated'
import { AppService } from './app.service'
import { LoaderService } from './loader.service'

@Injectable({ providedIn: 'root' })
export class AcfService {
  constructor(
    private loaderService: LoaderService,
    private getAllFieldsGQL: GetAllFieldsGQL,
    private getGroupFieldDefinitionByIdGQL: GetGroupFieldDefinitionByIdGQL,
    private appService: AppService,
    private getStringValueGQL: GetStringValueGQL,
    private getRichTextValueGQL: GetRichTextValueGQL,
    private getIntegerValueGQL: GetIntegerValueGQL,
    private getFloatValueGQL: GetFloatValueGQL,
    private getBooleanValueGQL: GetBooleanValueGQL,
    private getDateValueGQL: GetDateValueGQL,
    private getRelationValueGQL: GetRelationValueGQL,
    private getGroupValueGQL: GetGroupValueGQL,
    private getGroupValueByIdGQL: GetGroupValueByIdGQL,

    private getUniqueTemplatesGQL: GetUniqueTemplatesGQL,
    private getTemplatesByEntityIdGQL: GetTemplatesByEntityIdGQL
  ) {}

  getAllFields(input: GetAllFieldsInput) {
    return this.loaderService.withLoader(
      () =>
        this.getAllFieldsGQL
          .fetch(
            { input },
            {
              context: {
                headers: {
                  'vendure-token': this.appService.appStore$.getValue().channel,
                },
              },
              fetchPolicy: 'network-only',
            }
          )
          .pipe(map((res) => res.data?.getAllFields)),
      input.entityName
    )
  }

  getGroupFieldDefinitionById(id: string) {
    return this.loaderService.withLoader(
      () =>
        this.getGroupFieldDefinitionByIdGQL
          .fetch(
            { id },
            {
              context: {
                headers: {
                  'vendure-token': this.appService.appStore$.getValue().channel,
                },
              },
              fetchPolicy: 'network-only',
            }
          )
          .pipe(map((res) => res.data.getGroupFieldDefinitionById)),
      id
    )
  }

  getStringValue(input: GetStringValueInput) {
    return this.loaderService.withLoader(
      () =>
        this.getStringValueGQL
          .fetch(
            { input },
            {
              context: {
                headers: {
                  'vendure-token': this.appService.appStore$.getValue().channel,
                },
              },
              fetchPolicy: 'network-only',
            }
          )
          .pipe(map((res) => res.data.getStringValue)),
      input.entityId
    )
  }

  getRichTextValue(input: GetRichTextValueInput) {
    return this.loaderService.withLoader(
      () =>
        this.getRichTextValueGQL
          .fetch(
            { input },
            {
              context: {
                headers: {
                  'vendure-token': this.appService.appStore$.getValue().channel,
                },
              },
              fetchPolicy: 'network-only',
            }
          )
          .pipe(map((res) => res.data.getRichTextValue)),
      input.entityId
    )
  }

  getIntegerValue(input: GetIntegerValueInput) {
    return this.loaderService.withLoader(
      () =>
        this.getIntegerValueGQL
          .fetch(
            { input },
            {
              context: {
                headers: {
                  'vendure-token': this.appService.appStore$.getValue().channel,
                },
              },
              fetchPolicy: 'network-only',
            }
          )
          .pipe(map((res) => res.data.getIntegerValue)),
      input.entityId
    )
  }

  getFloatValue(input: GetFloatValueInput) {
    return this.loaderService.withLoader(
      () =>
        this.getFloatValueGQL
          .fetch(
            { input },
            {
              context: {
                headers: {
                  'vendure-token': this.appService.appStore$.getValue().channel,
                },
              },
              fetchPolicy: 'network-only',
            }
          )
          .pipe(map((res) => res.data.getFloatValue)),
      input.entityId
    )
  }

  getBooleanValue(input: GetBooleanValueInput) {
    return this.loaderService.withLoader(
      () =>
        this.getBooleanValueGQL
          .fetch(
            { input },
            {
              context: {
                headers: {
                  'vendure-token': this.appService.appStore$.getValue().channel,
                },
              },
              fetchPolicy: 'network-only',
            }
          )
          .pipe(map((res) => res.data.getBooleanValue)),
      input.entityId
    )
  }

  getDateValue(input: GetDateValueInput) {
    return this.loaderService.withLoader(
      () =>
        this.getDateValueGQL
          .fetch(
            { input },
            {
              context: {
                headers: {
                  'vendure-token': this.appService.appStore$.getValue().channel,
                },
              },
              fetchPolicy: 'network-only',
            }
          )
          .pipe(map((res) => res.data.getDateValue)),
      input.entityId
    )
  }

  getRelationValue(input: GetRelationValueInput) {
    return this.loaderService.withLoader(
      () =>
        this.getRelationValueGQL
          .fetch(
            { input },
            {
              context: {
                headers: {
                  'vendure-token': this.appService.appStore$.getValue().channel,
                },
              },
              fetchPolicy: 'network-only',
            }
          )
          .pipe(map((res) => res.data.getRelationValue)),
      input.entityId
    )
  }

  getGroupValue(input: GetGroupValueInput) {
    return this.loaderService.withLoader(
      () =>
        this.getGroupValueGQL
          .fetch(
            { input },
            {
              context: {
                headers: {
                  'vendure-token': this.appService.appStore$.getValue().channel,
                },
              },
              fetchPolicy: 'network-only',
            }
          )
          .pipe(map((res) => res.data.getGroupValue)),
      input.entityId
    )
  }

  getGroupValueById(id: string) {
    return this.loaderService.withLoader(
      () =>
        this.getGroupValueByIdGQL
          .fetch(
            { id },
            {
              context: {
                headers: {
                  'vendure-token': this.appService.appStore$.getValue().channel,
                },
              },
              fetchPolicy: 'network-only',
            }
          )
          .pipe(map((res) => res.data.getGroupValueById)),
      id
    )
  }

  getUniqueTemplates(entityName: string) {
    return this.loaderService.withLoader(
      () =>
        this.getUniqueTemplatesGQL.fetch(
          {
            entityName,
          },
          {
            context: {
              headers: {
                'vendure-token': this.appService.appStore$.getValue().channel,
              },
            },
            fetchPolicy: 'network-only',
          }
        ),
      entityName
    )
  }

  getTemplatesByEntityId(entityId: string) {
    return this.loaderService.withLoader(
      () =>
        this.getTemplatesByEntityIdGQL.fetch(
          {
            entityId,
          },
          {
            context: {
              headers: {
                'vendure-token': this.appService.appStore$.getValue().channel,
              },
            },
            fetchPolicy: 'network-only',
          }
        ),
      entityId
    )
  }

  getGroupMemberValueByFieldId(
    value: GroupValue,
    fieldName: string
  ): string | number | boolean {
    const member = value.members.find((member) => {
      return member.value.field.fieldName == fieldName
    })

    if (!member) {
      throw Error(`No member found with ${fieldName}`)
    }
    if (!member.value.__typename) {
      throw Error(`No member found with ${fieldName}`)
    }

    const key =
      member.value.__typename.charAt(0).toLowerCase() +
      member.value.__typename.slice(1)

    return member?.value[key]
  }
}
